import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsGraphComponent } from '../../../../mission-control/components/common/google-analytics-graph/google-analytics-graph.component';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';

interface ChartConfig {
  chartId: string;
  title: string;
  currencyFormat: boolean;
  beginAtZero: boolean;
  stepSize: number;
  backgroundColor: string;
  foregroundColor: string;
}

@Component({
  selector: 'app-google-analytics-panel',
  templateUrl: './google-analytics-panel.component.html',
  styleUrls: ['./google-analytics-panel.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    GoogleAnalyticsGraphComponent,
    CardModule
  ]
})
export class GoogleAnalyticsPanelComponent implements OnInit {
  chartConfigs: ChartConfig[][] = [
    [
      {
        chartId: 'unique-users',
        title: 'Unique Users (ppm.org)',
        currencyFormat: false,
        beginAtZero: true,
        stepSize: 5000,
        backgroundColor: 'rgba(147, 112, 219, 0.1)', // purple
        foregroundColor: 'rgba(147, 112, 219, 1)'
      },{
        chartId: 'adwords-spent',
        title: 'AdWords Spent (Google)',
        currencyFormat: true,
        beginAtZero: true,
        stepSize: 2500,
        backgroundColor: 'rgba(40, 167, 69, 0.1)', // green
        foregroundColor: 'rgba(40, 167, 69, 1)'
      },
    ],
    [
      {
        chartId: 'all-conversions',
        title: 'Group Leads (All)',
        currencyFormat: false,
        beginAtZero: true,
        stepSize: 100,
        backgroundColor: 'rgba(255, 193, 7, 0.1)', // yellow
        foregroundColor: 'rgba(255, 193, 7, 1)'
      },
      {
        chartId: 'adwords-conversions',
        title: 'Group Leads (AdWords)',
        currencyFormat: false,
        beginAtZero: true,
        stepSize: 50,
        backgroundColor: 'rgba(255, 193, 7, 0.1)', // yellow
        foregroundColor: 'rgba(255, 193, 7, 1)'
      }
    ]
  ];

  constructor() {}

  ngOnInit() {
    // Delay loading of AdWords charts to avoid rate limiting
    setTimeout(() => {
      this.loadAdWordsCharts = true;
    }, 1500);
  }

  loadAdWordsCharts = false;
} 